<ix-select
  [label]="label"
  [tooltip]="tooltip"
  [required]="required"
></ix-select>